<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<div class="mrfpd">
  <header class="mrfpd__page-head">
    <div class="mrfpd__title-row">
      <h1 class="mrfpd__title">Manpower Requisition Form</h1>
      <div class="mrf-header-statuses">
        <div class="mrf-header-status" *ngIf="requestStatusLabel">
          <span class="mrf-header-status__lbl">MRF Status</span>
          <span class="mrf-header-status__sep">-</span>
          <span class="mrf-header-status__val" [attr.data-tone]="requestStatusTone">{{ requestStatusLabel }}</span>
        </div>
        <div class="mrf-header-status" *ngIf="onboardingStatusLabel">
          <span class="mrf-header-status__lbl">Onboarding Status</span>
          <span class="mrf-header-status__sep">-</span>
          <span class="mrf-header-status__val" [attr.data-tone]="onboardingStatusTone">{{ onboardingStatusLabel }}</span>
        </div>
      </div>
    </div>
  </header>

  <div class="mrfpd__panel">
    <!-- 1 Basic Information -->
    <section class="mrfpd__sec mrfpd__sec--blue" aria-labelledby="mrfpd-s1">
      <span class="mrfpd__step mrfpd__step--blue" aria-hidden="true">1</span>
      <h2 id="mrfpd-s1" class="mrfpd__sec-title mrfpd__sec-title--blue">Basic Information</h2>
      <div class="mrfpd__row mrfpd__row--5">
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Campus Name</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display mrfpd__ro-val--select"
            [class.mrfpd__ro-val--empty]="!hasField('campusName')"
          >{{ displayPlaceholder('Select Entity', 'campusName') }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Employee Type</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display mrfpd__ro-val--select"
            [class.mrfpd__ro-val--empty]="!hasField('empType')"
          >{{ displayPlaceholder('Display', 'empType') }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Teaching Type</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display mrfpd__ro-val--select"
            [class.mrfpd__ro-val--empty]="!hasField('roleType', 'TeachType', 'teachingType', 'teachType')"
          >{{ displayPlaceholder('Display', 'roleType', 'TeachType', 'teachingType', 'teachType') }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Department</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display mrfpd__ro-val--select"
            [class.mrfpd__ro-val--empty]="!hasField('departmentName', 'deptName')"
          >{{ displayPlaceholder('Display', 'departmentName', 'deptName') }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Designation</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display mrfpd__ro-val--select"
            [class.mrfpd__ro-val--empty]="!hasField('desigName', 'designation')"
          >{{ displayPlaceholder('Display', 'desigName', 'designation') }}</span>
        </div>
        <div class="mrfpd__ro-fld" *ngIf="hasField('subName', 'subjectName')">
          <span class="mrfpd__ro-lbl">Subject</span>
          <span class="mrfpd__ro-val mrfpd__ro-val--display mrfpd__ro-val--select">
            {{ display('subName', 'subjectName') }}
          </span>
        </div>
        <div class="mrfpd__ro-fld" *ngIf="!isNonTeach">
          <span class="mrfpd__ro-lbl">WorkLoad per day</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display mrfpd__ro-val--select"
            [class.mrfpd__ro-val--empty]="!hasField('workLoad')"
          >{{ displayPlaceholder('Display', 'workLoad') }}</span>
        </div>
      </div>
    </section>

    <!-- 2 Position Type -->
    <section class="mrfpd__sec mrfpd__sec--purple" aria-labelledby="mrfpd-s2">
      <span class="mrfpd__step mrfpd__step--purple" aria-hidden="true">2</span>
      <h2 id="mrfpd-s2" class="mrfpd__sec-title mrfpd__sec-title--purple">Position Type</h2>
      <p class="mrfpd__lead">Whether replacement or a new position to the existing altogether?</p>
      <div class="mrfpd__pos-tabs" aria-label="Position type">
        <span class="mrfpd__pos-tab" [class.mrfpd__pos-tab--on]="isReplacement">Replacement</span>
        <span class="mrfpd__pos-tab" [class.mrfpd__pos-tab--on]="isNewPosition">New Position</span>
      </div>
      <div class="mrfpd__row mrfpd__row--pos-reason">
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Reason for hiring</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasField('hiringReason')"
          >{{ displayPlaceholder('Display', 'hiringReason') }}</span>
        </div>
        <div class="mrfpd__ro-fld" *ngIf="isReplacement">
          <span class="mrfpd__ro-lbl">Reason Description</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display mrfpd__ro-val--select"
            [class.mrfpd__ro-val--empty]="!reasonDescription"
          >{{ reasonDescription || 'Display' }}</span>
        </div>
      </div>
      <div class="mrfpd__row mrfpd__row--pos-rep" *ngIf="isReplacement">
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Employee Id</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasField('replacementEmpId', 'replacementPayrollId')"
          >{{ displayPlaceholder('Display', 'replacementEmpId', 'replacementPayrollId') }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Name</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasField('replacementEmpName')"
          >{{ displayPlaceholder('Display', 'replacementEmpName') }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Designation</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasField('replacementDesigName', 'replacementDesignation')"
          >{{ displayPlaceholder('Display', 'replacementDesigName', 'replacementDesignation') }}</span>
        </div>
        <div class="mrfpd__ro-fld" *ngIf="isReasonExit">
          <span class="mrfpd__ro-lbl">Last working date</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasField('lastWorkingDate', 'lastWorkingDay', 'lwd')"
          >{{ displayLastWorkingDate() }}</span>
        </div>
      </div>
      <div class="mrfpd__row mrfpd__row--pos-new" *ngIf="isNewPosition">
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Designation</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display mrfpd__ro-val--select"
            [class.mrfpd__ro-val--empty]="!hasField('newPositionDesigName', 'positionDesignation', 'posDesigName', 'desigName', 'designation')"
          >{{ displayPlaceholder('Display', 'newPositionDesigName', 'positionDesignation', 'posDesigName', 'desigName', 'designation') }}</span>
        </div>
      </div>
      <ng-container *ngIf="isRehiring && !canEditRehiringSection">
      <div class="mrfpd__chk" aria-label="Rehiring">
        <span class="mrfpd__chk-ui" [class.mrfpd__chk-ui--on]="isRehiring" aria-hidden="true"></span>
        <span class="mrfpd__chk-txt">Rehiring</span>
      </div>
      <div class="mrfpd__row mrfpd__row--pos-rehire" *ngIf="isRehiring && mrfData?.rehiringPayrollId">
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Rehiring Payroll Id</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasField('rehiringPayrollId')"
          >{{ displayPlaceholder('Display', 'rehiringPayrollId') }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Name</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasField('prevEmpName', 'newEmpName', 'newEmployeeName', 'employeeName', 'candidateName')"
          >{{ displayRehiringEmployeeName() }}</span>
        </div>
        <div class="mrfpd__ro-fld" *ngIf="hasRehiringAadharNo()">
          <span class="mrfpd__ro-lbl">Aadhaar No.</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasRehiringAadharNo()"
          >{{ displayRehiringAadharNo() }}</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: sharedAadhaarDocuments }"></ng-container>
        </div>
      </div>
      </ng-container>
    </section>

    <!-- 3 Headcount Information -->
    <section class="mrfpd__sec mrfpd__sec--green" aria-labelledby="mrfpd-s3">
      <span class="mrfpd__step mrfpd__step--green" aria-hidden="true">3</span>
      <h2 id="mrfpd-s3" class="mrfpd__sec-title mrfpd__sec-title--green">Headcount Information</h2>
      <div class="mrfpd__row mrfpd__row--2">
        <div class="mrfpd__ro-fld">
          <label class="mrfpd__ro-lbl" for="mrfpd-budgeted">No. of Budgeted Positions</label>
          <input
            id="mrfpd-budgeted"
            type="text"
            class="mrfpd__inp mrfpd__inp--dis"
            disabled
            [value]="budgetedPositions || '—'"
            placeholder="Default Values"
          />
        </div>
        <div class="mrfpd__ro-fld">
          <label class="mrfpd__ro-lbl" for="mrfpd-headcount">No. of Headcount</label>
          <input
            id="mrfpd-headcount"
            type="text"
            class="mrfpd__inp"
            [value]="noOfHeadcount"
            readonly
            aria-readonly="true"
          />
        </div>
      </div>
      <div class="mrfpd__hc-bar" role="status">
        <span class="mrfpd__hc-bar-ico" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM16 13C13.67 13 9 14.17 9 16.5V18H23V16.5C23 14.17 18.33 13 16 13ZM8 13C8.67 13 10.66 13.34 12 14.5C10.34 15.34 8.67 16 8 16C5.67 16 1 17.17 1 19.5V21H15V19.5C15 17.17 10.33 16 8 16Z"
              fill="#0CA766"
            />
          </svg>
        </span>
        <span class="mrfpd__hc-bar-lbl">Available Headcount (Budgeted - Actual)</span>
        <span class="mrfpd__hc-bar-val">{{ availableHeadcountDisplay }}</span>
      </div>
    </section>

    <!-- 4 Qualification & Skills -->
    <section class="mrfpd__sec mrfpd__sec--orange" aria-labelledby="mrfpd-s4">
      <span class="mrfpd__step mrfpd__step--orange" aria-hidden="true">4</span>
      <h2 id="mrfpd-s4" class="mrfpd__sec-title mrfpd__sec-title--orange">Qualification &amp; Skills</h2>
      <div class="mrfpd__row mrfpd__row--4">
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Educational Qualification</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasField('qualificationName', 'qualification')"
          >{{ displayPlaceholder('Display', 'qualificationName', 'qualification') }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Educational Qualification (Additional)</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasField('additionalQualification')"
          >{{ displayPlaceholder('Display', 'additionalQualification') }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Years of Experience</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasYearsOfExperience()"
          >{{ displayYearsOfExperience() }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Skills</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasField('skills')"
          >{{ displayPlaceholder('Display', 'skills') }}</span>
        </div>
      </div>
    </section>

    <!-- 5 Reporting Structure -->
    <section class="mrfpd__sec mrfpd__sec--teal" aria-labelledby="mrfpd-s5">
      <span class="mrfpd__step mrfpd__step--teal" aria-hidden="true">5</span>
      <h2 id="mrfpd-s5" class="mrfpd__sec-title mrfpd__sec-title--teal">Reporting Structure</h2>
      <div class="mrfpd__row mrfpd__row--1">
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Reporting Manager (Principal / Dean / AGM)</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasReportingManager()"
          >{{ displayReportingManager() }}</span>
        </div>
      </div>
    </section>

    <!-- 6 Qualified Employee Details -->
    <section class="mrfpd__sec mrfpd__sec--blue" aria-labelledby="mrfpd-s6">
      <span class="mrfpd__step mrfpd__step--blue" aria-hidden="true">6</span>
      <h2 id="mrfpd-s6" class="mrfpd__sec-title mrfpd__sec-title--blue">Qualified Employee Details</h2>

      <div class="mrfpd__row mrfpd__row--2 mrfpd__row--new-emp-head">
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Exam Taken</span>
          <div class="mrfpd__radio-row" role="radiogroup" aria-label="Exam taken" *ngIf="canEditQualifiedEmployeeSection">
            <label class="mrfpd__radio-opt" [class.mrfpd__radio-opt--on]="isExamTaken('yes')" [class.mrfpd__radio-opt--disabled]="!isTestSubject">
              <input
                type="radio"
                class="mrfpd__radio-inp"
                name="mrfpd-exam-taken"
                value="yes"
                [checked]="isExamTaken('yes')"
                [disabled]="!isTestSubject"
                (change)="setExamTaken('yes')"
              />
              <span class="mrfpd__radio-circle" aria-hidden="true"></span>
              Yes
            </label>
            <label class="mrfpd__radio-opt" [class.mrfpd__radio-opt--on]="isExamTaken('no')" [class.mrfpd__radio-opt--disabled]="examTakenLockedByAadhaar">
              <input
                type="radio"
                class="mrfpd__radio-inp"
                name="mrfpd-exam-taken"
                value="no"
                [checked]="isExamTaken('no')"
                [disabled]="examTakenLockedByAadhaar"
                (change)="setExamTaken('no')"
              />
              <span class="mrfpd__radio-circle" aria-hidden="true"></span>
              No
            </label>
          </div>
          <div class="mrfpd__radio-row" *ngIf="showQualifiedEmployeeAsReadOnly">
            <span class="mrfpd__radio-opt mrfpd__radio-opt--on">
              <span class="mrfpd__radio-circle" aria-hidden="true"></span>
              {{ isExamTaken('yes') ? 'Yes' : 'No' }}
            </span>
          </div>
        </div>
        <div class="mrfpd__ro-fld mrfpd__fld--autocomplete" *ngIf="isExamTaken('yes')">
          <span class="mrfpd__ro-lbl">Employee Temp Id</span>
          <ng-container *ngIf="canEditQualifiedEmployeeSection">
            <input
              id="mrfpd-emp-temp-id"
              type="text"
              class="mrfpd__inp mrfpd__inp--edit"
              matInput
              placeholder="Search temp employee (min 5 chars)"
              [formControl]="employeeTempId"
              [matAutocomplete]="tempEmpAuto"
              (focus)="refreshTempEmpAutocomplete()"
              autocomplete="off"
            />
            <mat-autocomplete
              #tempEmpAuto="matAutocomplete"
              autoActiveFirstOption
              [displayWith]="displayTempEmpLabel"
              (optionSelected)="onTempEmpSelected($event)"
            >
              <mat-option
                *ngFor="let item of tempEmpOptions | async; trackBy: trackByTempEmpId"
                [value]="item"
              >
                {{ getTempEmpOptionLabel(item) }}
              </mat-option>
            </mat-autocomplete>
          </ng-container>
          <span
            *ngIf="showQualifiedEmployeeAsReadOnly"
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!qualifiedHasField('employeeTempId', 'empTempId', 'tempEmpId')"
          >{{ displayEmployeeTempId() }}</span>
        </div>
        <div class="mrfpd__ro-fld" *ngIf="isExamTaken('yes')">
          <span class="mrfpd__ro-lbl">Previous Chaitanya Id</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasQualifiedPrevChaitanyaId()"
          >{{ displayQualifiedPrevChaitanyaId() }}</span>
        </div>
        <div class="mrfpd__ro-fld" *ngIf="isExamTaken('no') && hasTempPayrollId()">
          <span class="mrfpd__ro-lbl">Temp Payroll Id</span>
          <span
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasTempPayrollId()"
          >{{ displayTempPayrollId() }}</span>
        </div>
      </div>

      <div class="mrfpd__row mrfpd__row--5 mrfpd__row--new-emp-top">
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Name</span>
          <input
            *ngIf="canEnterNewEmployeeIdentityFields"
            id="mrfpd-employee-name"
            type="text"
            class="mrfpd__inp mrfpd__inp--edit"
            [formControl]="employeeName"
            placeholder="Enter"
            autocomplete="given-name"
          />
          <span
            *ngIf="!canEnterNewEmployeeIdentityFields"
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasQualifiedEmployeeName()"
          >{{ displayQualifiedEmployeeName() }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Surname</span>
          <input
            *ngIf="canEnterNewEmployeeIdentityFields"
            id="mrfpd-employee-surname"
            type="text"
            class="mrfpd__inp mrfpd__inp--edit"
            [formControl]="surname"
            placeholder="Enter"
            autocomplete="family-name"
          />
          <span
            *ngIf="!canEnterNewEmployeeIdentityFields"
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasSurname()"
          >{{ displaySurname() }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Mobile No.</span>
          <input
            *ngIf="canEditQualifiedEmployeeSection"
            id="mrfpd-mobile-no"
            type="text"
            class="mrfpd__inp mrfpd__inp--edit"
            [formControl]="mobileNo"
            placeholder="Enter 10 digits"
            maxlength="10"
            inputmode="numeric"
            autocomplete="tel"
            (input)="onMobileNoInput($event)"
          />
          <span
            *ngIf="showQualifiedEmployeeAsReadOnly"
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!qualifiedHasField('mobileNo', 'mobileNumber', 'candidateMobile', 'mobile', 'phoneNo', 'contactNo')"
          >{{ qualifiedDisplay('mobileNo', 'mobileNumber', 'candidateMobile', 'mobile', 'phoneNo', 'contactNo') }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Aadhaar Card No.</span>
          <input
            *ngIf="canEditQualifiedEmployeeSection"
            id="mrfpd-aadhaar-card-no"
            type="text"
            class="mrfpd__inp mrfpd__inp--edit"
            [formControl]="aadhaarCardNo"
            placeholder="Enter 12 digits"
            maxlength="12"
            inputmode="numeric"
            autocomplete="off"
            (input)="onAadhaarCardInput($event)"
          />
          <span
            *ngIf="showQualifiedEmployeeAsReadOnly"
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!qualifiedHasField('newEmpAadhar', 'aadharCardNo', 'candidateAadhar', 'aadharNo', 'aadhaarNo')"
          >{{ qualifiedDisplayPlaceholder('Display', 'newEmpAadhar', 'aadharCardNo', 'candidateAadhar', 'aadharNo', 'aadhaarNo') }}</span>
          <label
            class="mrfpd__attach-link"
            *ngIf="canEditQualifiedEmployeeSection && canAddMoreSharedAadhaarFiles()"
            (click)="onUploadClick($event, 'aadhaar', aadhaarFileInput)"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z" fill="#1B6EBA"/>
            </svg>
            Upload Aadhar
          </label>
          <input
            #aadhaarFileInput
            type="file"
            hidden
            accept=".pdf,image/*"
            (change)="onFilesSelected($event, 'aadhaar')"
          />
          <ng-container *ngIf="canEditQualifiedEmployeeSection">
            <ng-container *ngTemplateOutlet="pendingChips; context: { files: sharedAadhaarPendingFiles, type: 'aadhaar' }"></ng-container>
          </ng-container>
          <span class="mrfpd__field-error" *ngIf="getUploadFileError('aadhaar') || rehiringAadhaarUploadError">{{ getUploadFileError('aadhaar') || rehiringAadhaarUploadError }}</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: sharedAadhaarDocuments, showRemove: false }"></ng-container>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Pan Card No.</span>
          <input
            *ngIf="canEditQualifiedEmployeeSection"
            id="mrfpd-pan-no"
            type="text"
            class="mrfpd__inp mrfpd__inp--edit mrfpd__inp--uppercase"
            [class.mrfpd__inp--budget-error]="!!panValidationError"
            [formControl]="panNo"
            placeholder="Enter 10 character PAN"
            maxlength="10"
            autocapitalize="characters"
            spellcheck="false"
            autocomplete="off"
            (input)="onPanInput($event)"
          />
          <span
            class="mrfpd__field-error"
            *ngIf="canEditQualifiedEmployeeSection && panValidationError"
          >{{ panValidationError }}</span>
          <span
            *ngIf="showQualifiedEmployeeAsReadOnly"
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!qualifiedHasField('panNo', 'panCardNo', 'candidatePan', 'panNumber', 'panCardNumber', 'pancardNo')"
          >{{ qualifiedDisplay('panNo', 'panCardNo', 'candidatePan', 'panNumber', 'panCardNumber', 'pancardNo') }}</span>
          <label
            class="mrfpd__attach-link"
            *ngIf="canEditQualifiedEmployeeSection && !panDocuments.length && canAddMoreFiles('pan')"
            (click)="onUploadClick($event, 'pan', panFileInput)"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z" fill="#1B6EBA"/>
            </svg>
            Upload Pan
          </label>
          <input
            #panFileInput
            type="file"
            hidden
            accept=".pdf,image/*"
            (change)="onFilesSelected($event, 'pan')"
          />
          <ng-container *ngIf="canEditQualifiedEmployeeSection">
            <ng-container *ngTemplateOutlet="pendingChips; context: { files: panPendingFiles, type: 'pan' }"></ng-container>
          </ng-container>
          <span class="mrfpd__field-error" *ngIf="getUploadFileError('pan')">{{ getUploadFileError('pan') }}</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: panDocuments, showRemove: false }"></ng-container>
        </div>
      </div>

      <div class="mrfpd__row mrfpd__row--4 mrfpd__row--new-emp-bottom">
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">DOB</span>
          <input
            *ngIf="canEditQualifiedEmployeeSection"
            id="mrfpd-dob"
            type="date"
            class="mrfpd__inp mrfpd__inp--edit"
            [formControl]="dob"
          />
          <span
            *ngIf="showQualifiedEmployeeAsReadOnly"
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!qualifiedHasField('dob', 'dateOfBirth', 'employeeDob', 'newEmpDob')"
          >{{ displayDob() }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Gender</span>
          <select
            *ngIf="canEditQualifiedEmployeeSection"
            id="mrfpd-gender"
            class="mrfpd__inp mrfpd__inp--edit"
            [formControl]="gender"
          >
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <span
            *ngIf="showQualifiedEmployeeAsReadOnly"
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!hasGender()"
          >{{ displayGender() }}</span>
        </div>
        <div class="mrfpd__ro-fld">
          <span class="mrfpd__ro-lbl">Expected Salary</span>
          <input
            *ngIf="canEditQualifiedEmployeeSection"
            id="mrfpd-expected-salary"
            type="text"
            class="mrfpd__inp mrfpd__inp--edit"
            [class.mrfpd__inp--budget-error]="isExpectedSalaryOverAvailableBudget"
            [formControl]="expectedSalary"
            placeholder="Enter (only value)"
            maxlength="7"
            inputmode="numeric"
            autocomplete="off"
            (input)="onExpectedSalaryInput($event)"
          />
          <span
            *ngIf="showQualifiedEmployeeAsReadOnly"
            class="mrfpd__ro-val mrfpd__ro-val--display"
            [class.mrfpd__ro-val--empty]="!qualifiedHasField('expectedSalary', 'salaryBudget', 'salary', 'expectedCTC')"
          >{{ qualifiedDisplayPlaceholder('Enter (only value)', 'expectedSalary', 'salaryBudget', 'salary', 'expectedCTC') }}</span>
        </div>
        <div class="mrfpd__ro-fld mrfpd__new-emp-upload" *ngIf="isExamTaken('yes')">
          <label
            *ngIf="canEditQualifiedEmployeeSection"
            class="mrfpd__upload-btn"
            [class.mrfpd__upload-btn--disabled]="!canAddMoreFiles('exam')"
            (click)="onUploadClick($event, 'exam', examFileInput)"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 16L7 11H10V4H14V11H17L12 16ZM5 20H19V18H5V20Z" fill="#1B6EBA"/>
            </svg>
            Upload Exam Copy
          </label>
          <span *ngIf="showQualifiedEmployeeAsReadOnly" class="mrfpd__ro-lbl">Upload Exam Copy</span>
          <input
            #examFileInput
            type="file"
            hidden
            accept=".pdf,application/pdf"
            (change)="onFilesSelected($event, 'exam')"
          />
          <ng-container *ngIf="canEditQualifiedEmployeeSection">
            <ng-container *ngTemplateOutlet="pendingChips; context: { files: examPendingFiles, type: 'exam' }"></ng-container>
          </ng-container>
          <span class="mrfpd__field-error" *ngIf="getUploadFileError('exam')">{{ getUploadFileError('exam') }}</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: examDocuments, showRemove: false }"></ng-container>
        </div>
      </div>

      <!-- <div
        class="mrfpd__row mrfpd__row--1 mrfpd__row--new-emp-demo"
        *ngIf="showPrincipalActions || demoVideoDocuments.length || demoVideoPendingFiles.length"
      >
        <div class="mrfpd__ro-fld mrfpd__new-emp-upload">
          <label
            *ngIf="showPrincipalActions"
            class="mrfpd__upload-btn"
            [class.mrfpd__upload-btn--disabled]="!canAddMoreFiles('demo')"
            (click)="onUploadClick($event, 'demo', demoFileInput)"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 16L7 11H10V4H14V11H17L12 16ZM5 20H19V18H5V20Z" fill="#1B6EBA"/>
            </svg>
            Upload Demo Video
          </label>
          <span *ngIf="isReadOnlyView" class="mrfpd__ro-lbl">Upload Demo Video</span>
          <input
            #demoFileInput
            type="file"
            hidden
            accept="video/*,.mov,.mp4,.avi,.webm,.mkv"
            (change)="onFilesSelected($event, 'demo')"
          />
          <ng-container *ngIf="showPrincipalActions">
            <ng-container *ngTemplateOutlet="pendingChips; context: { files: demoVideoPendingFiles, type: 'demo' }"></ng-container>
          </ng-container>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: demoVideoDocuments, showRemove: false }"></ng-container>
        </div>
      </div> -->

      <ng-container *ngIf="showRehiringSection">
        <label class="mrfpd__chk">
          <input
            type="checkbox"
            class="mrfpd__chk-inp"
            [checked]="rehiring"
            [disabled]="isRehiringFieldsLocked"
            (change)="onRehiringChange($event)"
          />
          <span class="mrfpd__chk-ui" [class.mrfpd__chk-ui--on]="rehiring" aria-hidden="true"></span>
          <span class="mrfpd__chk-txt">Rehiring</span>
        </label>

        <div class="mrfpd__row mrfpd__row--3 mrfpd__row--pos-rehire" *ngIf="rehiring">
          <div class="mrfpd__ro-fld mrfpd__fld--autocomplete">
            <span class="mrfpd__ro-lbl">Previous Payroll Id</span>
            <ng-container *ngIf="!isRehiringFieldsLocked; else lockedPrevPayroll">
              <input
                id="mrfpd-prev-payroll-id"
                type="text"
                class="mrfpd__inp mrfpd__inp--edit"
                matInput
                placeholder="Enter name, payroll, aadhar or mobile (min 5 chars)"
                [formControl]="prevChaitanyaId"
                [matAutocomplete]="prevLeftEmpAuto"
                (focus)="refreshRehiringLeftEmpAutocomplete()"
                autocomplete="off"
              />
              <mat-autocomplete
                #prevLeftEmpAuto="matAutocomplete"
                autoActiveFirstOption
                [displayWith]="displayPrevLeftEmpLabel"
                (optionSelected)="onPrevLeftEmpSelected($event)"
              >
                <mat-option
                  *ngFor="let item of prevLeftEmpOptions | async; trackBy: trackByLeftEmpId"
                  [value]="item"
                >
                  {{ getLeftEmpOptionLabel(item) }}
                </mat-option>
              </mat-autocomplete>
            </ng-container>
            <ng-template #lockedPrevPayroll>
              <input
                id="mrfpd-prev-payroll-id-ro"
                type="text"
                class="mrfpd__inp mrfpd__inp--dis"
                readonly
                tabindex="-1"
                [value]="prevChaitanyaIdDisplay"
              />
            </ng-template>
          </div>
          <div class="mrfpd__ro-fld">
            <span class="mrfpd__ro-lbl">Date of Birth</span>
            <input
              id="mrfpd-rehiring-dob"
              type="text"
              class="mrfpd__inp mrfpd__inp--dis"
              placeholder="Display"
              readonly
              [value]="rehiringDobDisplay"
            />
          </div>
          <div class="mrfpd__ro-fld">
            <span class="mrfpd__ro-lbl">Aadhaar No.</span>
            <input
              id="mrfpd-rehiring-aadhaar"
              type="text"
              class="mrfpd__inp"
              [class.mrfpd__inp--edit]="!isRehiringFieldsLocked"
              [class.mrfpd__inp--dis]="isRehiringFieldsLocked"
              placeholder="Enter 12 digit Aadhaar"
              [formControl]="rehireAadharNo"
              [readonly]="isRehiringFieldsLocked"
              maxlength="12"
              inputmode="numeric"
              autocomplete="off"
              (input)="onRehireAadhaarInput($event)"
            />
            <label
              class="mrfpd__attach-link"
              *ngIf="canAddMoreSharedAadhaarFiles() && !isRehiringFieldsLocked"
              (click)="onRehiringAadhaarAttachClick($event, rehiringAadhaarFileInput)"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z" fill="#1B6EBA"/>
              </svg>
              Upload Aadhar
            </label>
            <input
              #rehiringAadhaarFileInput
              type="file"
              hidden
              accept=".pdf,image/*"
              (change)="onRehiringAadhaarFilesSelected($event)"
            />
            <ng-container *ngTemplateOutlet="pendingChips; context: { files: sharedAadhaarPendingFiles, type: 'rehiringAadhaar' }"></ng-container>
            <span class="mrfpd__field-error" *ngIf="rehiringAadhaarUploadError || getUploadFileError('aadhaar')">{{ rehiringAadhaarUploadError || getUploadFileError('aadhaar') }}</span>
            <ng-container *ngTemplateOutlet="fileChips; context: { docs: sharedAadhaarDocuments, showRemove: false }"></ng-container>
          </div>
        </div>
      </ng-container>
    </section>

    <!-- 7 Important Guidelines -->
    <section class="mrfpd__sec mrfpd__sec--gold mrfpd__sec--last" aria-labelledby="mrfpd-s7">
      <span class="mrfpd__step mrfpd__step--gold" aria-hidden="true">7</span>
      <h2 id="mrfpd-s7" class="mrfpd__sec-title mrfpd__sec-title--gold">Important Guidelines</h2>
      <div class="mrfpd__guide-box">
        <ul class="mrfpd__guide">
          <li>
            Any position that is substituted should have a replacement salary that is less than 10% of the current salary.
          </li>
          <li>
            If the new campus is inaugurated under any dean, whether it is a replacement or a new branch offering the same programs, the average salary will be applicable according to the remaining branches within his zone.
          </li>
          <li>
            If a new branch offers different programs, align its average fee with that of a comparable branch and adopt the average salary of that branch.
          </li>
        </ul>
      </div>
    </section>

    <footer class="mrfpd__footer">
      <button type="button" class="mrfpd__btn mrfpd__btn--cancel" (click)="cancel()" [disabled]="isSaving">Cancel</button>
      <ng-container *ngIf="showPrincipalApprovalActions || showPrincipalEditMode || showMisEditMode">
        <button type="button" class="mrfpd__btn mrfpd__btn--approve" (click)="submitReview('APPROVED')" [disabled]="disablePrincipalApprovalActions">
          {{ isSaving ? 'Submitting...' : 'Approve' }}
        </button>
      </ng-container>
    </footer>
  </div>
</div>

<ng-template #pendingChips let-files="files" let-type="type">
  <ul class="mrfpd__pending" *ngIf="files?.length">
    <li *ngFor="let file of files; let i = index" class="mrfpd__pending-item">
      <span
        class="mrfpd__file-chip-ico"
        [class.mrfpd__file-chip-ico--pdf]="!isPendingVideo(file)"
        [class.mrfpd__file-chip-ico--video]="isPendingVideo(file)"
      >{{ isPendingVideo(file) ? '▶' : 'PDF' }}</span>
      <span class="mrfpd__pending-name" [title]="file.name">{{ file.name }}</span>
      <button
        type="button"
        class="mrfpd__pending-remove"
        (click)="removePendingFile(type, i)"
        aria-label="Remove file"
      >×</button>
    </li>
  </ul>
</ng-template>

<ng-template #fileChips let-docs="docs" let-showRemove="showRemove">
  <div class="mrfpd__file-chips" *ngIf="docs?.length">
    <ng-container *ngFor="let doc of docs">
      <button
        type="button"
        *ngIf="canDownloadDocument(doc); else fileChipStatic"
        class="mrfpd__file-chip"
        (click)="onDocumentDownload(doc)"
        [title]="getDocumentName(doc)"
      >
        <span
          class="mrfpd__file-chip-ico"
          [class.mrfpd__file-chip-ico--pdf]="isPdfFile(doc)"
          [class.mrfpd__file-chip-ico--video]="isVideoFile(doc)"
          [class.mrfpd__file-chip-ico--img]="isImageFile(doc)"
        >{{ getDocumentIconLabel(doc) }}</span>
        <span class="mrfpd__file-chip-name">{{ getDocumentName(doc) }}</span>
        <span class="mrfpd__file-chip-remove" *ngIf="showRemove" aria-hidden="true">×</span>
      </button>
      <ng-template #fileChipStatic>
        <span class="mrfpd__file-chip mrfpd__file-chip--static" [title]="getDocumentName(doc)">
          <span
            class="mrfpd__file-chip-ico"
            [class.mrfpd__file-chip-ico--pdf]="isPdfFile(doc)"
            [class.mrfpd__file-chip-ico--video]="isVideoFile(doc)"
            [class.mrfpd__file-chip-ico--img]="isImageFile(doc)"
          >{{ getDocumentIconLabel(doc) }}</span>
          <span class="mrfpd__file-chip-name">{{ getDocumentName(doc) }}</span>
          <span class="mrfpd__file-chip-remove" *ngIf="showRemove" aria-hidden="true">×</span>
        </span>
      </ng-template>
    </ng-container>
  </div>
</ng-template>
